import script from "./EditEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEvent.vue?vue&type=script&setup=true&lang=js"

import "./EditEvent.vue?vue&type=style&index=0&id=eca6f804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eca6f804"]])

export default __exports__